import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import AuditLogsLayer from '../components/AuditLogsLayer';

const AuditLogsPage = () => {
    return (
        <MasterLayout>
            <AuditLogsLayer />
        </MasterLayout>
    );
};

export default AuditLogsPage;
